import {
  SectionElement,
  defineElement,
  globalOn,
  liquidValue
} from "./chunk-DNDL4K7L.js";
import {
  __async,
  __decorateClass
} from "./chunk-XDKWOSVF.js";

// src/sections/common-product-slider/common-product-slider.ts
var CommonProductSlider = class extends SectionElement {
  constructor() {
    super(...arguments);
    this.grayBullets = [];
    this.slideChangeHandler = () => {
      this.updateGrayBullets();
    };
  }
  connectedCallback() {
    if (!this.recommendation)
      return;
    this.fetchRecommendations();
  }
  handleSwiperInit() {
    const swiperComponent = this.querySelector("util-swiper[data-product-swiper]");
    const swiperInstance = swiperComponent == null ? void 0 : swiperComponent.swiperInstance;
    if (swiperInstance == null)
      return;
    if (this.activeSwiper === swiperInstance) {
      this.collectGrayBullets();
      this.updateGrayBullets();
      return;
    }
    this.cleanGraySlider();
    this.activeSwiper = swiperInstance;
    this.collectGrayBullets();
    this.updateGrayBullets();
    swiperInstance.on("slideChange", this.slideChangeHandler);
  }
  fetchRecommendations() {
    return __async(this, null, function* () {
      var _a;
      try {
        const response = yield fetch((_a = this.getAttribute("data-url")) != null ? _a : "");
        const text = yield response.text();
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector("common-product-slider");
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.cleanGraySlider();
          this.innerHTML = recommendations.innerHTML;
        }
      } catch (e) {
        console.error(e);
      }
    });
  }
  collectGrayBullets() {
    this.grayBullets = Array.from(this.querySelectorAll("[data-gray-bullet]"));
    this.grayBullets.forEach((bullet) => {
      var _a;
      bullet.dataset.active = (_a = bullet.dataset.active) != null ? _a : "false";
    });
  }
  updateGrayBullets() {
    var _a, _b;
    if (this.grayBullets.length === 0)
      return;
    const activeIndex = (_b = (_a = this.activeSwiper) == null ? void 0 : _a.realIndex) != null ? _b : 0;
    this.grayBullets.forEach((bullet, index) => {
      const isActive = index === activeIndex;
      bullet.dataset.active = isActive ? "true" : "false";
    });
  }
  cleanGraySlider() {
    this.activeSwiper = void 0;
    this.grayBullets = [];
  }
};
__decorateClass([
  liquidValue("section.settings.recommendation")
], CommonProductSlider.prototype, "recommendation", 2);
__decorateClass([
  globalOn("commonProductSlider:init")
], CommonProductSlider.prototype, "handleSwiperInit", 1);
CommonProductSlider = __decorateClass([
  defineElement("common-product-slider")
], CommonProductSlider);
export {
  CommonProductSlider
};
